export const PHONE_DISPLAY = "+7 908 449-49-00";
export const PHONE_WHATSAPP = "79084494900"; // wa.me format, digits only

export function whatsappLink(message) {
  return `https://wa.me/${PHONE_WHATSAPP}?text=${encodeURIComponent(message)}`;
}

export const translations = {
  ru: {
    nav: {
      home: "Главная",
      ochno: "Очные занятия",
      online: "Онлайн",
      about: "О тренере",
      corporate: "Корпоративным",
    },
    footer: {
      tagline: "Тренер высшей категории по спортивной гимнастике",
      bookOchno: "Запись очно",
      bookOnline: "Запись онлайн",
      rights: "Все права защищены.",
    },
    home: {
      metaTitle: "Наталья Нургалиева — тренер по спортивной гимнастике и фитнесу",
      name: "Нургалиева Наталья Николаевна",
      kicker: "Тренер высшей категории · 30+ лет опыта",
      credentials: "Тренер по спортивной гимнастике · Состав молодёжной сборной СССР · Судья Федерации гимнастики России",
      question: "Как вы хотите тренироваться?",
      cardATitle: "Очные занятия",
      cardASub: "во Владивостоке",
      cardADesc: "Гимнастика для детей и взрослых",
      cardACta: "Выбрать",
      cardBTitle: "Онлайн-тренировки",
      cardBSub: "по видеосвязи",
      cardBDesc: "Персональный фитнес из любой точки мира",
      cardBCta: "Выбрать",
      aboutTeaserTitle: "Коротко о Наталье Николаевне",
      bullet1: "Сборная СССР",
      bullet2: "30+ лет тренерской практики",
      bullet3: "Судья Федерации гимнастики России",
      aboutMore: "Подробнее о тренере",
    },
    ochno: {
      heroTitle: "Спортивная гимнастика во Владивостоке",
      heroSubtitle: "Тренер высшей категории. Экс-сборная СССР.",
      heroCta: "Записаться на пробное занятие",
      trust1: "30+ лет опыта",
      trust2: "Экс-сборная СССР",
      trust3: "Судья ФГР",
      trust4: "Более 100 учеников",
      groupsTitle: "Для кого",
      group1Title: "4–6 лет",
      group1Desc: "Первые шаги в гимнастике, общая физическая подготовка в игровой форме",
      group2Title: "7–12 лет",
      group2Desc: "Развитие силы, гибкости, разрядные программы, подготовка к соревнованиям",
      group3Title: "13+ и взрослые",
      group3Desc: "Общая физическая подготовка, растяжка, элементы акробатики для любого уровня",
      scheduleTitle: "Расписание групповых тренировок",
      scheduleGroup: "Группа",
      scheduleTime: "Время",
      scheduleDays: "Дни недели",
      scheduleLocation: "Местоположение",
      resultsTitle: "Результаты учеников",
      resultsSubtitle: "Медали, грамоты и победы на соревнованиях",
      reviewsTitle: "Отзывы родителей",
      galleryTitle: "Галерея",
      gallerySubtitle: "Видео и фотографии с тренировок",
      galleryCta: "Смотреть все фото и видео",
      bookingTitle: "Записаться на пробное занятие",
      bookingSubtitle: "Напишите нам в WhatsApp или Telegram — ответим в течение дня",
      bookingWhatsapp: "Написать в WhatsApp",
      bookingMessage: "Здравствуйте! Хочу записать ребёнка на пробное занятие по гимнастике.",
      corporateTeaser: "Также проводим корпоративные тренировки для команд и компаний.",
      corporateLink: "Подробнее →",
    },
    online: {
      heroTitle: "Персональные тренировки по видеосвязи",
      heroSubtitle: "Сила, гибкость и уверенность — с тренером и бывшей участницей молодежной сборной СССР, из любой точки мира",
      heroCta: "Записаться на консультацию со скидкой",
      introTitle: "Меня зовут Наталья",
      introText: "Я тренер высшей категории по спортивной гимнастике с более чем 30-летним опытом. Я тренировала детей и взрослых с самыми разными целями — от первых шагов в спорте до стойки на руках для удовольствия. Теперь я провожу персональные тренировки по видеосвязи, чтобы помочь вам стать сильнее, гибче и увереннее в себе — независимо от того, где вы находитесь.",
      stepsTitle: "Как это работает",
      step1: "Консультация со скидкой",
      step1Desc: "Обсудим ваши цели и текущий уровень подготовки",
      step2: "Индивидуальный план",
      step2Desc: "Составим программу тренировок под ваши задачи",
      step3: "Регулярные сессии по видео",
      step3Desc: "Тренируемся вместе в удобное для вас время",
      step4: "Прогресс и поддержка",
      step4Desc: "Отслеживаем результаты и корректируем план",
      outcomesTitle: "Для кого эти тренировки",
      outcome1Title: "Стойка на руках",
      outcome1Desc: "Хотите научиться стоять на руках или сделать сальто? Разберём технику с нуля.",
      outcome2Title: "Гибкость и шпагат",
      outcome2Desc: "Безопасная растяжка и прогресс к шпагату в своём темпе.",
      outcome3Title: "Общая физическая форма",
      outcome3Desc: "Укрепление мышц, осанка, выносливость — просто быть в хорошей форме.",
      trustTitle: "Почему мне доверяют",
      trustDesc: "Я тренировалась в молодежной сборной СССР, более 30 лет работаю тренером, сужу соревнования и состою в Федерации гимнастики России. Я знаю, как построить тренировку безопасно и эффективно — для любого уровня подготовки.",
      pricingTitle: "Цены и пакеты",
      pricingNote: "Точные цены обсуждаются индивидуально на консультации со скидкой",
      tier1Title: "Разовая сессия",
      tier1Price: "по запросу",
      tier1Desc: "Познакомиться с форматом, попробовать тренировку",
      tier2Title: "4 сессии в месяц",
      tier2Price: "по запросу",
      tier2Desc: "Регулярные тренировки раз в неделю",
      tier3Title: "8 сессий в месяц",
      tier3Price: "по запросу",
      tier3Desc: "Два раза в неделю, быстрее прогресс",
      pricingCta: "Узнать цены",
      faqTitle: "Частые вопросы",
      faq1Q: "Нужен специальный инвентарь?",
      faq1A: "Нет, для большинства тренировок достаточно коврика и свободного места. Если что-то понадобится — подскажу заранее.",
      faq2Q: "Как проходит видео-звонок?",
      faq2A: "Созваниваемся в удобном для вас приложении (WhatsApp, Telegram, Zoom). Я показываю упражнения и корректирую технику в реальном времени.",
      faq3Q: "А если я в другом часовом поясе?",
      faq3A: "Не проблема — подберём удобное время при первом контакте.",
      faq4Q: "Можно перенести или отменить тренировку?",
      faq4A: "Да, просто напишите заранее — согласуем новое время.",
      bookingTitle: "Забронируйте консультацию со скидкой",
      bookingSubtitle: "Напишите нам, и мы согласуем удобное время для первого звонка",
      bookingWhatsapp: "Написать в WhatsApp",
      bookingMessage: "Здравствуйте! Хочу узнать больше об онлайн-тренировках.",
    },
    about: {
      heroTitle: "Нургалиева Наталья Николаевна",
      heroSubtitle: "Тренер высшей категории по спортивной гимнастике · Состав молодёжной сборной СССР · Судья по спортивной гимнастике",
      timelineTitle: "Карьера и достижения",
      t1: "Член молодежной сборной СССР",
      t2: "30+ лет тренерской практики",
      t3: "Судья соревнований",
      t4: "Член Федерации гимнастики России",
      t5: "Опыт работы с детьми, взрослыми, командами других видов спорта и корпоративными группами",
      storyTitle: "История",
      story1: "Наталья Николаевна является тренером высшей категории по спортивной гимнастике, в настоящее время проживает во Владивостоке. В молодости Наталья была членом молодежной сборной Советского Союза.",
      story2: "Она тренирует детей и взрослых с различными целями уже более 30 лет — от первых шагов в спорте до подготовки к соревнованиям. Наталья также проводит занятия для команд из других видов спорта и корпоративные программы по физической подготовке.",
      story3: "Наталья судит соревнования и является членом Федерации гимнастики России.",
      ctaOchno: "Записаться очно",
      ctaOnline: "Записаться онлайн",
    },
    corporate: {
      heroTitle: "Корпоративные тренировки",
      heroDesc: "Корпоративные тренировки становятся все более популярными, и на то есть веские причины! Инвестируя в корпоративные тренировки, компании могут повысить моральный дух команды, увеличить продуктивность и снизить уровень стресса среди сотрудников.",
      heroDesc2: "Наталья предлагает специализированные корпоративные тренировки, направленные на улучшение командного духа и физической формы. Эти занятия могут быть адаптированы под конкретные потребности вашей организации.",
      cta: "Обсудить программу",
      ctaMessage: "Здравствуйте! Хочу обсудить корпоративную программу тренировок.",
    },
    reviews: [
      {
        title: "Зенченко Татьяна Николаевна",
        description: "Заслуженный мастер спорта России по самбо, трёхкратная чемпионка Мира и Европы по самбо",
        quote: "Своего сына Тимура привела заниматься к тренеру по гимнастике Наталье Николаевне в 4 года. Сейчас ему 8 лет. Благодаря Наталье Николаевне, мой сын физически окреп, выполнил программу 3юн. разрядов по спортивной гимнастике. Хочется отметить не только профессиональные, но и педагогические качества тренера.",
      },
      {
        title: "Фалеева Оксана Анатольевна",
        description: "Заслуженный тренер России по самбо, Заслуженный мастер спорта России по самбо",
        quote: "В 3 года привела своего сына Юру на занятия по общей физической подготовке к Наталье Николаевне. Сейчас сыну 10 лет, он подготовлен на 6 снарядах по программе 2 спортивного разряда и является одних из лучших в школе.",
      },
      {
        title: "Родители Ромы",
        quote: "Первые успехи Ромы! В этом Ваша большая заслуга! Спасибо, что столько лет вкладывались в него!",
      },
    ],
    schedule: [
      { className: "Общая физическая подготовка (ОФП)", time: "11:00 – 12:00", days: "суббота, воскресенье", location: 'СК "Молодёжный", проспект 100-летия Владивостока, 7Б' },
      { className: "Общая физическая подготовка (ОФП)", time: "17:00 – 18:00", days: "среда, пятница", location: "ул. Пограничная, 12Б" },
    ],
  },

  en: {
    nav: {
      home: "Home",
      ochno: "In-person classes",
      online: "Online",
      about: "About",
      corporate: "Corporate",
    },
    footer: {
      tagline: "Elite gymnastics coach",
      bookOchno: "Book in person",
      bookOnline: "Book online",
      rights: "All rights reserved.",
    },
    home: {
      metaTitle: "Natalia Nurgalieva — Gymnastics & Fitness Coach",
      name: "Natalia Nurgalieva",
      kicker: "Elite coach · 30+ years of experience",
      credentials: "Gymnastics coach · Former USSR youth national team member · Judge, Russian Gymnastics Federation",
      question: "How would you like to train?",
      cardATitle: "In-person classes",
      cardASub: "in Vladivostok",
      cardADesc: "Gymnastics for kids and adults",
      cardACta: "Choose",
      cardBTitle: "Online coaching",
      cardBSub: "via video call",
      cardBDesc: "Personal fitness training from anywhere",
      cardBCta: "Choose",
      aboutTeaserTitle: "About Natalia",
      bullet1: "Former USSR national team member",
      bullet2: "30+ years of coaching experience",
      bullet3: "Judge, Russian Gymnastics Federation",
      aboutMore: "Learn more about Natalia",
    },
    ochno: {
      heroTitle: "Gymnastics classes in Vladivostok",
      heroSubtitle: "Elite coach. Former USSR youth national team member.",
      heroCta: "Book a trial class",
      trust1: "30+ years experience",
      trust2: "Former USSR team member",
      trust3: "Certified judge",
      trust4: "100+ students",
      groupsTitle: "Who it's for",
      group1Title: "Ages 4–6",
      group1Desc: "First steps in gymnastics, general physical prep through play",
      group2Title: "Ages 7–12",
      group2Desc: "Strength, flexibility, competition-level programs",
      group3Title: "13+ and adults",
      group3Desc: "General fitness, stretching, acrobatic basics for any level",
      scheduleTitle: "Group class schedule",
      scheduleGroup: "Group",
      scheduleTime: "Time",
      scheduleDays: "Days",
      scheduleLocation: "Location",
      resultsTitle: "Student results",
      resultsSubtitle: "Medals, certificates, and competition wins",
      reviewsTitle: "Parent reviews",
      galleryTitle: "Gallery",
      gallerySubtitle: "Photos and videos from training",
      galleryCta: "See all photos & videos",
      bookingTitle: "Book a trial class",
      bookingSubtitle: "Message us on WhatsApp or Telegram — we usually reply within a day",
      bookingWhatsapp: "Message on WhatsApp",
      bookingMessage: "Hello! I'd like to book a trial gymnastics class for my child.",
      corporateTeaser: "We also offer corporate training for teams and companies.",
      corporateLink: "Learn more →",
    },
    online: {
      heroTitle: "Personal training via video call",
      heroSubtitle: "Strength, flexibility, and confidence — with an elite coach and former USSR youth national team member, from anywhere",
      heroCta: "Book a discounted consultation",
      introTitle: "My name is Natalia",
      introText: "I'm a gymnastics coach certified at Russia's highest coaching qualification category, with over 30 years of experience. I've trained children and adults with all kinds of goals — from first steps in sport to learning a handstand for fun. Now I offer personal training over video call to help you get stronger, more flexible, and more confident — wherever you are.",
      stepsTitle: "How it works",
      step1: "Discounted consultation",
      step1Desc: "We'll discuss your goals and current fitness level",
      step2: "Personalized plan",
      step2Desc: "I'll design a training program around your goals",
      step3: "Regular video sessions",
      step3Desc: "We train together at a time that works for you",
      step4: "Progress & support",
      step4Desc: "We track your progress and adjust the plan as needed",
      outcomesTitle: "Who this is for",
      outcome1Title: "Handstands & tricks",
      outcome1Desc: "Want to learn a handstand or a flip? We'll build the technique from scratch.",
      outcome2Title: "Flexibility & splits",
      outcome2Desc: "Safe stretching progressions toward the splits, at your own pace.",
      outcome3Title: "General fitness",
      outcome3Desc: "Build strength, posture, and stamina — just want to be in good shape.",
      trustTitle: "Why clients trust me",
      trustDesc: "I trained with the USSR youth national team, have coached for over 30 years, judge competitions, and am a member of the Russian Gymnastics Federation. I know how to build a safe, effective training plan for any fitness level.",
      pricingTitle: "Pricing & packages",
      pricingNote: "Exact pricing is discussed individually during your discounted consultation",
      tier1Title: "Single session",
      tier1Price: "on request",
      tier1Desc: "Try the format with a single session",
      tier2Title: "4 sessions / month",
      tier2Price: "on request",
      tier2Desc: "Weekly training sessions",
      tier3Title: "8 sessions / month",
      tier3Price: "on request",
      tier3Desc: "Twice a week for faster progress",
      pricingCta: "Ask about pricing",
      faqTitle: "Frequently asked questions",
      faq1Q: "Do I need special equipment?",
      faq1A: "No — a mat and some open floor space is enough for most sessions. If anything else is needed, I'll let you know in advance.",
      faq2Q: "How does the video call work?",
      faq2A: "We hop on a call using whatever app works best for you (WhatsApp, Telegram, Zoom). I demonstrate exercises and correct your form in real time.",
      faq3Q: "What if I'm in a different time zone?",
      faq3A: "No problem — we'll find a time that works during our first conversation.",
      faq4Q: "Can I reschedule or cancel a session?",
      faq4A: "Yes, just message in advance and we'll find a new time.",
      bookingTitle: "Book your discounted consultation",
      bookingSubtitle: "Message us and we'll find a good time for your first call",
      bookingWhatsapp: "Message on WhatsApp",
      bookingMessage: "Hello! I'd like to learn more about online training.",
    },
    about: {
      heroTitle: "Natalia Nurgalieva",
      heroSubtitle: "Elite gymnastics coach · Former USSR youth national team member · Certified artistic gymnastics judge",
      timelineTitle: "Career & achievements",
      t1: "Former USSR youth national team member",
      t2: "30+ years of coaching experience",
      t3: "Competition judge",
      t4: "Member, Russian Gymnastics Federation",
      t5: "Experience coaching children, adults, athletes from other sports, and corporate groups",
      storyTitle: "Her story",
      story1: "Natalia is an elite gymnastics coach certified at Russia's highest coaching qualification category, currently based in Vladivostok. In her youth, she was a member of the Soviet Union's youth national team.",
      story2: "For over 30 years she has coached children and adults with a wide range of goals — from first steps in sport to competition preparation. She also trains teams from other sports and leads corporate fitness programs.",
      story3: "Natalia judges competitions and is a member of the Russian Gymnastics Federation.",
      ctaOchno: "Book in-person",
      ctaOnline: "Book online",
    },
    corporate: {
      heroTitle: "Corporate training",
      heroDesc: "Corporate training programs are increasingly popular — and for good reason. Investing in team fitness can boost morale, increase productivity, and reduce employee stress.",
      heroDesc2: "Natalia offers specialized corporate training focused on team spirit and physical fitness, tailored to your organization's specific needs.",
      cta: "Discuss a program",
      ctaMessage: "Hello! I'd like to discuss a corporate training program.",
    },
    reviews: [
      {
        title: "Tatiana Zenchenko",
        description: "Honored Master of Sports of Russia (Sambo), three-time World and European Sambo champion",
        quote: "I brought my son Timur to Natalia's gymnastics group at age 4. He's 8 now. Thanks to Natalia, my son has grown physically stronger and completed the junior-level gymnastics program. I want to highlight not just her professional skill, but her teaching approach — she finds an individual way to reach every child.",
      },
      {
        title: "Oksana Faleeva",
        description: "Honored Coach of Russia (Sambo), Honored Master of Sports of Russia",
        quote: "I brought my son Yura to Natalia's general fitness classes at age 3. He's 10 now, trained on 6 apparatus at a 2nd-category level, and is one of the best in the school.",
        },
      {
        title: "Roma's parents",
        quote: "Roma's first successes! This is largely thanks to you! Thank you for investing in him for all these years!",
      },
    ],
    schedule: [
      { className: "General fitness (OFP)", time: "11:00 – 12:00", days: "Sat, Sun", location: '"Molodyozhny" Sports Center, 7B 100-letiya Vladivostoka Ave.' },
      { className: "General fitness (OFP)", time: "17:00 – 18:00", days: "Wed, Fri", location: "12B Pogranichnaya St." },
    ],
  },
};
